import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import Button from "../../../components/button";
import LoadingSpinner from '../../../components/loading-spinner';
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SelectInput from "../../../components/select";
import Input from "../../../components/input";
import {
    searchActivityItem,
    confirmActivity,
    CONFIRM_ACTIVITY,
    clear_activity,
    updateActivity,
    UPDATE_ACTIVITY,
    createActivityLog,
    CREATE_ACTIVITY_LOG
} from "../../../redux/activities";
import Footer from "../../../components/footer";
import {ReactComponent as ReactLogo} from '../../../button.svg';
// import {URLAPI} from "../../../config";
import TextArea from "../../../components/text-area";
import Modal from "../../../components/modal";
import Select from "react-select";
import { 
    clear_update_activity,
     CREATE_UPDATE_ACTIVITY, 
     createUpdateActivity 
} from "../../../redux/update_activity";

const ActivityItem = (props) => {
    let history = useHistory();
    const {id, idUsuario, nombreUsuario, idTienda, nombreTienda, fechaInicio, fechaFin} = useParams();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _get_all_result_states = useSelector((state) => state.result_states_module._get_all_result_states);
    const _get_all_responsibles = useSelector((state) => state.responsibles_module._get_all_responsibles);
    const _confirm_activity = useSelector((state) => state.activities_module._confirm_activity);
    const _update_activity = useSelector((state) => state.activities_module._update_activity);
    const _create_activity_log = useSelector((state) => state.activities_module._create_activity_log);
    const _create_update_activity = useSelector((state) => state.update_activity_module._create_update_activity);
    const _get_all_risk_impact = useSelector((state) => state.risk_impact_module._get_all_risk_impact);

    const [isLoading, setIsLoading] = useState(false);

    const [data, setData] = useState({});
    const [images, setImages] = useState([]);
    const [resources, setResources] = useState([]);
    const [aditionals, setAditionals] = useState([]);
    const [responsibles, setResponsibles] = useState([]);
    const [states, setStates] = useState([]);
    const [rickImpacts, setRickImpacts] = useState([]);
    const [modalDelete, setModalDelete] = useState(false);
    const [modalReagendar, setModalReagendar] = useState(false);
    const [newDate, setNewDate] = useState('');
    const [responsibles_select, setResponsiblesSelect] = useState([]);

    const [form, setForm] = useState({
        id_observacion: 0,
        observacion: "",
        comentario: "",
        id_estado: 0,
        estado_campo_obligatorio: false,
        estado: "",
        /* id_responsable: 0,
        responsable: "", */
        responsables: [],
        id_riesgo: 0,
        riesgo: "",
        id_impacto_riesgo: 0,
        impacto_riesgo: "",
        valor_impacto_riesgo: 0,
        latitud: "",
        longitud: "",
        notificar: false,
        matrix: false,
    });

    useEffect(() => {
        // eslint-disable-next-line
        getActivity(token);
        // eslint-disable-next-line
        getGeolocation();
        // eslint-disable-next-line
    }, [token, id]);

    async function getActivity(token) {
        setIsLoading(true);
        try {
            const response = await searchActivityItem(token, id);
            if (response && response.data && response.data.datos) {
                let v = response.data.datos;
                setData(v);
                setResources(v.resultados);
                setAditionals(v.adicionales);
                let responsables = v.responsables.map((re) => {
                    return {
                        value: re.id,
                        label: re.nombre,
                    };
                })
                setResponsiblesSelect(responsables);
                setForm({
                    id_observacion: v.id_observacion,
                    observacion: v.observacion,
                    comentario: v.comentario,
                    id_estado_resultado: v.id_estado_resultado,
                    estado_resultado: v.estado_resultado,
                    estado_campo_obligatorio: v.estado_campo_obligatorio,
                    /* id_responsable: v.id_responsable,
                    responsable: v.responsable, 
                    responsables: v.responsables,*/
                    id_riesgo: v.id_riesgo,
                    riesgo: v.riesgo,
                    id_impacto_riesgo: v.id_impacto_riesgo,
                    impacto_riesgo: v.descripcion_impacto_riesgo,
                    valor_impacto_riesgo: v.valor_impacto_riesgo,
                    latitud: "",
                    longitud: "",
                    notificar: false,
                    matrix: v.matrix,
                })
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    useEffect(() => {
        if (_get_all_result_states.data.datos) {
            let options = _get_all_result_states.data.datos.filter(x => x.activo === true);
            setStates(options);
        }
    }, [_get_all_result_states, id]);

    useEffect(() => {
        if (_get_all_risk_impact.data.datos) {
            let options = _get_all_risk_impact.data.datos.filter(x => x.activo === true);
            setRickImpacts(options);
        }
    }, [_get_all_risk_impact, id]);

    useEffect(() => {
        if (_get_all_responsibles.data.datos) {
            let options = [];
            // eslint-disable-next-line
            _get_all_responsibles.data.datos.map((item) => {
                if (item.activo === true){
                    options.push({
                        value: item.id,
                        label: item.nombre,
                    });
                }
            });
            setResponsibles(options);
        }
    }, [_get_all_responsibles, id]);

    function getGeolocation() {
        // setIsLoading(true);
        navigator.geolocation.getCurrentPosition(
            function (position) {
                setForm({
                    ...form,
                    latitud: position.coords.latitude,
                    longitud: position.coords.longitude,
                });
            },
            (err) => {console.log(err)},
            {enableHighAccuracy: false, timeout: 27000, maximumAge: 30000});
    }

    const handleFileChangeImage = (e) => {
        setImages([
            ...images,
            e.target.files[0]
        ]);
    };

    const handleFileChangeResource = (e, id_template) => {
        let files = [];
        for (var ft of resources) {
            if (parseInt(ft.id_template) === parseInt(id_template)) {
                files.push({
                    'id': ft.id,
                    'nombre': e.target.files[0].name,
                    'archivo': e.target.files[0],
                    'tipo': e.target.files[0].type,
                    'id_template': ft.id_template,
                    'nombre_template': ft.nombre_template,
                    'archivo_template': ft.archivo_template,
                });
            } else {
                files.push({
                    'id': ft.id,
                    'nombre': ft.nombre,
                    'archivo': ft.archivo,
                    'tipo': ft.tipo,
                    'id_template': ft.id_template,
                    'nombre_template': ft.nombre_template,
                    'archivo_template': ft.archivo_template,
                });
            }
        }
        setResources(files);
    };

    const handleChange = (e) => {
        if (e.target.name === "id_observacion" || e.target.name === "id_riesgo" || e.target.name === "id_impacto_riesgo") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else if(e.target.name === "id_estado_resultado"){
            let state = states.filter(x => x.id === parseInt(e.target.value));
            if (state.length > 0){
                setForm({
                    ...form,
                    [e.target.name]: parseInt(e.target.value),
                    estado_campo_obligatorio: state[0].campo_obligatorio,
                });
            }
        } else if(e.target.name === "valor_impacto_riesgo"){
            setForm({
                ...form,
                [e.target.name]: parseFloat(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleChangeAditonal = (e) => {
        let adicionales = []
        for (var ad of aditionals) {
            let v = ad.value;
            if (ad.label === e.target.name) {
                v = e.target.value
            }
            adicionales.push({
                label: ad.label,
                value: v
            })
        }
        setAditionals(adicionales); 
    };


    useEffect(() => {
        if (_create_update_activity.status === 201) {
            dispatch(clear_update_activity(CREATE_UPDATE_ACTIVITY));
            toast.success(_create_update_activity.data.datos.mensaje, {position: toast.POSITION.TOP_RIGHT});
            getActivity(token);
            setIsLoading(false);
        } else if (_create_update_activity.status !== 0) {
            dispatch(clear_update_activity(CREATE_UPDATE_ACTIVITY));
            toast.error(_create_update_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_update_activity, dispatch, token]);
    
    useEffect(() => {
        if (_confirm_activity.status === 200) {
            dispatch(clear_activity(CONFIRM_ACTIVITY));
            // getActivity();
            history.push(`/actividades/${idUsuario}/${nombreUsuario}/${idTienda}/${nombreTienda}/${fechaInicio}/${fechaFin}`);
            setIsLoading(false);
        } else if (_confirm_activity.status !== 0) {
            dispatch(clear_activity(CONFIRM_ACTIVITY));
            toast.error(_confirm_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_confirm_activity, dispatch, history, token]);

    useEffect(() => {
        if (_update_activity.status === 200) {
            dispatch(clear_activity(UPDATE_ACTIVITY));
            // getActivity();
            history.push(`/actividades/${idUsuario}/${nombreUsuario}/${idTienda}/${nombreTienda}/${fechaInicio}/${fechaFin}`);
            setIsLoading(false);
        } else if (_update_activity.status !== 0) {
            dispatch(clear_activity(UPDATE_ACTIVITY));
            toast.error(_update_activity.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_activity, dispatch, history, token]);

    function _confirmActivity() {
        setIsLoading(true);
        getGeolocation();
        for (var f of resources) {
            if (!f.archivo) {
              toast.error("Falta agregar resultado(s)", {position: toast.POSITION.TOP_RIGHT});
              setIsLoading(false);
              return;
            }
        }
        if (form.id_observacion === 0) {
            toast.error("Debe seleccionar una observación", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_estado_resultado === 0) {
            toast.error("Debe seleccionar un estado", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        } else {
            if (form.estado_campo_obligatorio){
                if (form.id_riesgo === 0) {
                    toast.error("Debe seleccionar un riesgo", {position: toast.POSITION.TOP_RIGHT});
                    setIsLoading(false);
                    return;
                }
            }
        }

        if (responsibles_select.length === 0) {
            toast.error("Debe seleccionar un responsable", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        /* if (form.id_responsable === 0) {
            toast.error("Debe seleccionar un responsable", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        } */

        if (!form.comentario) {
            toast.error("Debe ingresar un comentario", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }

        for (var ad of aditionals) {
            if (!ad.value) {
              toast.error("Falta agregar datos adicionales", {position: toast.POSITION.TOP_RIGHT});
              setIsLoading(false);
              return;
            }
        }

        if (data.impacto_riesgo) {
            if (form.id_impacto_riesgo === 0) {
               toast.error("Debe seleccionar una clasificación de impacto de riesgo", {position: toast.POSITION.TOP_RIGHT});
               setIsLoading(false);
               return;
            }
            // if (form.valor_impacto_riesgo === 0) {
            //    toast.error("Debe ingresar el valor de impacto de riesgo", {position: toast.POSITION.TOP_RIGHT});
            //    setIsLoading(false);
            //    return;
            // }
        }

        const value = new FormData();
        resources.forEach((file, i) => {
            if (file.tipo) {
                value.append(`resultados`, file.archivo, file.nombre + ',' + file.id.toString());
            }
        });
        images.forEach((file, i) => {
            value.append(`imagenes`, file, file.name);
        });
        responsibles_select.forEach((r) => {
            value.append(`responsables`, r.value);
        });
        value.append('id_observacion', form.id_observacion);
        value.append('id_estado_resultado', form.id_estado_resultado);
        value.append('id_riesgo', form.id_riesgo);
        // value.append('id_responsable', form.id_responsable);
        value.append('comentario', form.comentario);
        value.append('latitud', form.latitud);
        value.append('longitud', form.longitud);
        value.append('matrix', form.matrix);
        value.append('adicionales', JSON.stringify(aditionals));
        value.append('id_impacto_riesgo', form.id_impacto_riesgo);
        value.append('valor_impacto_riesgo', form.valor_impacto_riesgo);
        let not = '0'
        if (form.notificar) {
            not = '1'
        }
        value.append('notificacion', not);
        value.append('hecho', '1');
        dispatch(confirmActivity(token, id, value));
    }

    function _saveActivity() {
        setIsLoading(true);
        const value = new FormData();
        resources.forEach((file, i) => {
            if (file.tipo) {
                value.append(`resultados`, file.archivo, file.nombre + ',' + file.id.toString());
            }
        });
        images.forEach((file, i) => {
            value.append(`imagenes`, file, file.name);
        });
        // if (form.id_observacion === 0) {
        //     toast.error("Debe seleccionar una observación", {position: toast.POSITION.TOP_RIGHT});
        //     setIsLoading(false);
        //     return;
        // }
        // if (form.id_estado_resultado === 0) {
        //     toast.error("Debe seleccionar un estado", {position: toast.POSITION.TOP_RIGHT});
        //     setIsLoading(false);
        //     return;
        // } else {
        //     if (form.estado_campo_obligatorio){
        //         if (form.id_riesgo === 0) {
        //             toast.error("Debe seleccionar un riesgo", {position: toast.POSITION.TOP_RIGHT});
        //             setIsLoading(false);
        //             return;
        //         }
        //     }
        // }
        // if (responsibles_select.length === 0) {
        //     toast.error("Debe seleccionar un responsable", {position: toast.POSITION.TOP_RIGHT});
        //     setIsLoading(false);
        //     return;
        // }
        if (form.id_observacion !== 0) {
            value.append('id_observacion', form.id_observacion);
        }
        if (form.id_estado_resultado !== 0) {
            value.append('id_estado_resultado', form.id_estado_resultado);
        }
        if (form.id_riesgo !== 0) {
            value.append('id_riesgo', form.id_riesgo);
        }
        if (form.comentario !== '') {
            value.append('comentario', form.comentario);
        }
        if (form.id_impacto_riesgo !== 0) {
            value.append('id_impacto_riesgo', form.id_impacto_riesgo);
        }
        if (form.valor_impacto_riesgo !== 0) {
            value.append('valor_impacto_riesgo', form.valor_impacto_riesgo);
        }
        value.append('matrix', form.matrix);
        let valid = true
        for (var ad of aditionals) {
            if (!ad.value) {
              valid = false
            }
        }
        if (valid) {
            value.append('adicionales', JSON.stringify(aditionals));
        }
        
        responsibles_select.forEach((r) => {
            value.append(`responsables`, r.value);
        });

        value.append('notificacion', 0);
        value.append('hecho', '0');
        dispatch(confirmActivity(token, id, value));
    }

    function update_activity(v) {
        setIsLoading(true);
        dispatch(updateActivity(token, id, {'tipo': v, 'nueva_fecha': newDate}));
    }

    useEffect(() => {
        if (_create_activity_log.status === 201) {
            dispatch(clear_activity(CREATE_ACTIVITY_LOG));
            var type = _create_activity_log.data.datos.tipo;
            if(type === 'INICIAR' || type === 'CONTINUAR') {
                getActivity(token);
            }
            // setIsLoading(false);
        } else if (_create_activity_log.status !== 0) {
            dispatch(clear_activity(CREATE_ACTIVITY_LOG));
            toast.error(_create_activity_log.message, {position: toast.POSITION.TOP_RIGHT});
            // setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_activity_log, dispatch, history, token]);

    function logActivity(name) {
        // setIsLoading(true);
        dispatch(createActivityLog(token, {'nombre': name, 'id_actividad': id}));
    }

    const handleChangeSelect = (e) => {
        setResponsiblesSelect(e);
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            {isLoading && <LoadingSpinner/>}
            <div><ToastContainer/></div>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Agenda"
                            items={[{label: "Consulta de agenda", link: `/actividades/${idUsuario}/${nombreUsuario}/${idTienda}/${nombreTienda}/${fechaInicio}/${fechaFin}`}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="d-flex">
                                    <div style={{cursor: 'pointer'}} onClick={() => {
                                        history.push(`/actividades/${idUsuario}/${nombreUsuario}/${idTienda}/${nombreTienda}/${fechaInicio}/${fechaFin}`);
                                    }}>
                                        <ReactLogo width={50} heght={40}/>
                                    </div>
                                    <p className="ml-1" style={{marginTop: 5, fontSize: 18, color: '#727E8C'}}>{data.actividad}</p>
                                </div>
                                <div className="border_card row" style={{background: data.color_div}}>
                                    <div className='col-md-6 col-sm-12'>
                                        <div className="d-flex">
                                            <p style={{marginRight: 15}}>
                                                <small>Fecha agendada</small><br/>
                                                <strong>{data.fecha_agendada}</strong>
                                            </p>
                                            <p style={{marginRight: 15}}>
                                                <small>Estado actividad</small><br/>
                                                <strong>{data.estado}</strong>
                                            </p>
                                            <p style={{marginRight: 15}}>
                                                <small>Tienda</small><br/>
                                                <strong>{data.tienda}</strong>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-sm-12 text-right'>
                                        {!data.readonly ?
                                                (data.log === 'INICIAR' || data.log === 'CONTINUAR' || data.log === 'FINALIZAR') && 
                                                    <>
                                                        <Button type="button" text="Eliminar" theme="danger" classes="m-1" onChange={() => {
                                                            setModalDelete(true);
                                                        }}/>
                                                        {!data.reprogramado &&
                                                            <Button type="button" text="Reagendar" theme="calendar" classes="m-1" onChange={() => {
                                                                setNewDate('');
                                                                setModalReagendar(true);
                                                            }}/>
                                                        }
                                                    </>
                                            :
                                            <p style={{marginRight: 5}}>
                                                <small>Estado resultado</small><br/>
                                                <strong>{data.estado_resultado}</strong>
                                            </p>
                                        }
                                        
                                    </div>
                                </div>
                                {(data.log === 'INICIAR' || data.log === 'CONTINUAR' || data.log === 'FINALIZAR') &&
                                    <>
                                        <div className="row mt-1">
                                            {data.descripcion_actividad &&
                                                <div className="border_card col-12" style={{background: "#f2f2f2"}}>
                                                    <p>Descripción: {data.descripcion_actividad}</p>
                                                </div>
                                            }
                                            <div className="col-12">
                                                <p className="text-title">Archivos de resultados</p>
                                            </div>
                                            {(resources) &&
                                                resources.map((_) => (
                                                    <div className="col-md-6 col-12 border_card d-flex">
                                                        <div style={{marginTop: 5, width: '50%'}}>
                                                            <div>
                                                                <strong className="ml-1">{_.nombre_template}</strong><br/>
                                                                {!_.archivo ?
                                                                        <span className="ml-1">Pendiente</span>
                                                                    :
                                                                        <span className="ml-1">Cargado</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        {!_.archivo ?
                                                            <div className="ml-1 d-flex">
                                                                <div className="mr-2">
                                                                    {/*eslint-disable-next-line*/}
                                                                    <a href={_.archivo_template} target="_blank" className="ml-1">Descargar</a>
                                                                </div>
                                                                <div className="text-center">
                                                                    {/*eslint-disable-next-line*/}
                                                                    <a style={{
                                                                        position: 'absolute', cursor: 'pointer'
                                                                    }}>Cargar
                                                                    </a>
                                                                    <input type="file"
                                                                        onChange={(e) => handleFileChangeResource(e, _.id_template)}
                                                                        style={{
                                                                            opacity: 0,
                                                                            width: 160,
                                                                            height: 40,
                                                                            cursor: 'pointer'
                                                                        }}/>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="ml-1 d-flex">
                                                                {!data.readonly &&
                                                                    <div className="mr-2">
                                                                        {/*eslint-disable-next-line*/}
                                                                        <a href={_.archivo_template} target="_blank"
                                                                        className="ml-1">Descargar</a>
                                                                    </div>
                                                                }
                                                                {/*eslint-disable-next-line*/}
                                                                <div className="mr-2">
                                                                    {/*eslint-disable-next-line*/}
                                                                    <a href={_.archivo} target="_blank"
                                                                    className="ml-1">Ver</a>
                                                                </div>
                                                                {!data.readonly &&
                                                                    <div>
                                                                        {/*eslint-disable-next-line*/}
                                                                        <a style={{
                                                                            position: 'absolute', cursor: 'pointer'
                                                                        }}>Actualizar
                                                                        </a>
                                                                        <input type="file" onChange={(e) => handleFileChangeResource(e, _.id_template)}
                                                                            style={{opacity: 0, width: 160, height: 40, cursor: 'pointer'}}/>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className="row mt-1">
                                            <div className="col-12">
                                                <p className="text-title">Fotografías de evidencia</p>
                                            </div>
                                            <div className="col-12 border_card">
                                                <div className="row">
                                                    <div className="col-md-8 col-12">
                                                        <div className="row">
                                                            {(data && data.imagenes && data.imagenes.length > 0) &&
                                                                data.imagenes.map((_) => (
                                                                    <div className="col-4 text-center">
                                                                        <img
                                                                            src={_.imagen}
                                                                            width={100}
                                                                            height={90}
                                                                            alt={_.nombre}
                                                                        />
                                                                    </div>
                                                                ))
                                                            }
                                                            {(images) &&
                                                                images.map((_) => (
                                                                    <div className="col-4 text-center d-flex">
                                                                        <img
                                                                            src={URL.createObjectURL(_)}
                                                                            width={100}
                                                                            height={90}
                                                                            alt={_.name}
                                                                        />
                                                                        {/*eslint-disable-next-line*/}
                                                                        <a href="#" onClick={() => {
                                                                            const index = images.indexOf(_);
                                                                            images.splice(index, 1);
                                                                            setImages([...images]);
                                                                        }}>
                                                                            <img
                                                                                src={
                                                                                    window.location.origin +
                                                                                    "/base/app-assets/images/icon/close.png"
                                                                                }
                                                                                width={25}
                                                                                height={25}
                                                                                alt="Eliminar"
                                                                                style={{
                                                                                    marginLeft: 5,
                                                                                    borderRadius: 25,
                                                                                    backgroundColor: '#f3cece',
                                                                                    padding: 4
                                                                                }}
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    {!data.readonly &&
                                                        <div className="col-md-4 col-12 text-right">
                                                            {data && data.imagenes && ((images.length + data.imagenes.length) < 3) &&
                                                                <div className="mt-1">
                                                                    <button className="btn text-bold-700" style={{
                                                                        position: 'absolute',
                                                                        background: '#0D2339',
                                                                        fontSize: 14,
                                                                        color: '#FFFFFF',
                                                                        width: '50%'
                                                                    }}>Tomar foto
                                                                    </button>
                                                                    <input accept="image/*" type="file"
                                                                        onChange={handleFileChangeImage}
                                                                        multiple style={{opacity: 0, width: '60%', height: 40}}/>
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-1">
                                            <div className="col-12">
                                                <p className="text-title">Observaciones finales</p>
                                            </div>
                                            <div className="col-12 border_card">
                                                <div className="row">
                                                    <div className="col-md-4 col-12">
                                                        <div className="form-group">
                                                            <label>Observación final</label>
                                                            <SelectInput
                                                                label="Actividad"
                                                                name="id_observacion"
                                                                value={form.id_observacion}
                                                                select={form.observacion}
                                                                onChange={handleChange}
                                                                options={data.observaciones ? data.observaciones.map((item) => ({
                                                                    name: item.nombre,
                                                                    id: item.id,
                                                                })) : []}
                                                                disabled={data.disabled}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-12">
                                                        <div className="form-group">
                                                            <label>Estado</label>
                                                            <SelectInput
                                                                label="Estado"
                                                                name="id_estado_resultado"
                                                                value={form.id_estado_resultado}
                                                                select={form.estado_resultado}
                                                                onChange={handleChange}
                                                                options={states ? states.map((item) => ({
                                                                    name: item.nombre,
                                                                    id: item.id,
                                                                    campo_obligatorio: item.campo_obligatorio
                                                                })) : []}
                                                                disabled={data.disabled}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-12">
                                                        <div className="form-group">
                                                            <label>Riesgo</label>
                                                            <SelectInput
                                                                label="Riesgo"
                                                                name="id_riesgo"
                                                                value={form.id_riesgo}
                                                                select={form.riesgo}
                                                                onChange={handleChange}
                                                                options={data.riesgos ? data.riesgos.map((item) => ({
                                                                    name: item.nombre,
                                                                    id: item.id,
                                                                })) : []}
                                                                disabled={data.disabled}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                    {!data.disabled &&
                                                        <div className="col-md-4 col-12">
                                                            <div className="form-check mt-1">
                                                                <label className="form-check-label">
                                                                    <input type="checkbox" className="form-check-input"
                                                                        onClick={() => {
                                                                            setForm({
                                                                                ...form,
                                                                                notificar: !form.notificar,
                                                                            });
                                                                        }} checked={form.notificar}
                                                                        style={{width: 15, height: 15, marginTop: -1}}/>
                                                                    <span className="ml-1">Notificar a administración</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    }
                                                    {!data.disabled &&
                                                        <div className="col-md-4 col-12">
                                                            <div className="form-check mt-1">
                                                                <label className="form-check-label">
                                                                    <input type="checkbox" className="form-check-input"
                                                                        onClick={() => {
                                                                            setForm({
                                                                                ...form,
                                                                                matrix: !form.matrix,
                                                                            });
                                                                        }} checked={form.matrix}
                                                                        style={{width: 15, height: 15, marginTop: -1}}/>
                                                                    <span className="ml-1">Incluir en matríz</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className="col-12 mt-1">
                                                        <div className="form-group">
                                                            <label>Responsables</label>
                                                            <Select
                                                                options={responsibles}
                                                                isMulti={true}
                                                                onChange={handleChangeSelect}
                                                                value={responsibles_select}
                                                                isDisabled={data.disabled}
                                                            />
                                                            {/* <SelectInput
                                                                label="Responsable"
                                                                name="id_responsable"
                                                                value={form.id_responsable}
                                                                select={form.responsable}
                                                                onChange={handleChange}
                                                                options={responsibles ? responsibles.map((item) => ({
                                                                    name: item.nombre,
                                                                    id: item.id,
                                                                })) : []}
                                                                disabled={data.readonly}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <TextArea
                                                                id="comentario"
                                                                name="comentario"
                                                                label="Comentario"
                                                                placeholder=""
                                                                value={form.comentario}
                                                                onChange={handleChange}
                                                                rows={2}
                                                                disabled={data.disabled}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-1">
                                            <div className="col-12">
                                                <p className="text-title">Datos adicionales</p>
                                            </div>
                                            {(aditionals && aditionals.length > 0) &&
                                                <div className="col-12 border_card">
                                                    <div className="row">
                                                        {aditionals.map((x, index) => (
                                                            <div className="col-md-4 col-12">
                                                                <div className="form-group">
                                                                    <Input
                                                                        name={x.label}
                                                                        label={x.label}
                                                                        value={x.value}
                                                                        onChange={handleChangeAditonal}
                                                                        disabled={data.disabled}
                                                                    />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {data.impacto_riesgo &&
                                            <div className="row mt-1">
                                                <div className="col-12">
                                                    <p className="text-title">Impacto del riesgo</p>
                                                </div>
                                                <div className="col-12 border_card">
                                                    <div className="row">
                                                        <div className="col-md-4 col-12">
                                                            <div className="form-group">
                                                                <label>Clasificación</label>
                                                                <SelectInput
                                                                    label="Clasificación"
                                                                    name="id_impacto_riesgo"
                                                                    value={form.id_impacto_riesgo}
                                                                    select={form.impacto_riesgo}
                                                                    onChange={handleChange}
                                                                    options={rickImpacts ? rickImpacts.map((item) => ({
                                                                        name: item.descripcion,
                                                                        id: item.id,
                                                                    })) : []}
                                                                    disabled={data.disabled}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-12">
                                                            <div className="form-group">
                                                                <Input
                                                                    name="valor_impacto_riesgo"
                                                                    label="Valor"
                                                                    value={form.valor_impacto_riesgo}
                                                                    onChange={handleChange}
                                                                    disabled={data.disabled}
                                                                    type="number"
                                                                    min="0"
                                                                    step="0.01"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                                <div className="mt-2 text-right">
                                    {!data.readonly ?
                                        (data.log === '' || data.log === 'PAUSAR') ?
                                            data.log === '' ?
                                                <Button disabled={isLoading} type="button" text="Iniciar actividad" theme="calendar" classes="m-1" onChange={() => {
                                                    logActivity('INICIAR');
                                                }}/>
                                            :
                                                <Button disabled={isLoading} type="button" text="Continuar actividad" theme="calendar" classes="m-1" onChange={() => {
                                                    logActivity('CONTINUAR');
                                                }}/>
                                        :
                                            <>
                                                <Button disabled={isLoading} type="button" text="Finalizar actividad" theme="calendar" classes="m-1" onChange={() => {
                                                    logActivity("FINALIZAR");
                                                    _confirmActivity();
                                                }}/>
                                                <Button disabled={isLoading} type="button" text="Pausar actividad" theme="calendar" classes="m-1" onChange={() => {
                                                    logActivity("PAUSAR");
                                                    _saveActivity();
                                                }}/>
                                                <Button disabled={isLoading} type="button" text="Guardar" theme="calendar" classes="m-1" onChange={() => {
                                                    _saveActivity();
                                                }}/>
                                            </>
                                    :
                                        <>
                                            {data.actualizar ?
                                                <Button disabled={isLoading} type="button" text="Finalizar actividad" theme="calendar" classes="m-1" onChange={() => {
                                                    logActivity("FINALIZAR");
                                                    _confirmActivity();
                                                }}/>
                                                :
                                                !data.solicitar_permiso &&
                                                    <Button disabled={isLoading} type="button" text="Permiso de edición" theme="calendar" classes="m-1" onChange={() => {
                                                        setIsLoading(true);
                                                        dispatch(createUpdateActivity(token, {id_actividad: data.id, estado: 'PENDIENTE'}));
                                                    }}/>
                                                
                                            }
                                        
                                            <Button disabled={isLoading} type="button" text="Atrás" theme="calendar" classes="m-1" onChange={() => {
                                                history.push(`/actividades/${idUsuario}/${nombreUsuario}/${idTienda}/${nombreTienda}/${fechaInicio}/${fechaFin}`);
                                            }}/>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main" show={modalDelete} style={{width: "70%"}}>
                <div className="m-1 text-center">
                    <img
                        src={window.location.origin + "/base/app-assets/images/icon/help.png"}
                        alt="img"
                        height="96"
                        width="96"
                    />
                    <br/><br/>
                    <p className='texto_24'>¿Desea eliminar la tarea?</p>
                    <br/><br/>
                    {/*eslint-disable-next-line*/}
                    <a href="#" onClick={() => {
                        update_activity("ELIMINAR");
                    }} className="btn text-bold-700 mb-1 btn_1">
                        SI
                    </a>
                    {/*eslint-disable-next-line*/}
                    <a href="#" onClick={() => {
                        setModalDelete(false);
                    }} className="btn text-bold-700 btn_3">
                        No
                    </a>
                </div>
            </Modal>
            <Modal className="modal-main" show={modalReagendar} style={{width: "70%"}}>
                <div className="card-body">
                    <h5 className="titulo_modal type_text mb-2">Reagendar actividad</h5>
                    <div className="form-group">
                        <Input
                            label="Fecha"
                            name="newDate"
                            value={newDate}
                            type="date"
                            onChange={(e) => setNewDate(e.target.value)}
                        />
                    </div>
                </div>
                <div className="m-1 text-center">
                    {/*eslint-disable-next-line*/}
                    <a href="#" onClick={() => {
                        update_activity("REAGENDAR");
                    }} className="btn text-bold-700 mb-1 btn_1">
                        Guardar
                    </a>
                    {/*eslint-disable-next-line*/}
                    <a href="#" onClick={() => {
                        setModalReagendar(false);
                    }} className="btn text-bold-700 btn_3">
                        Cancelar
                    </a>
                </div>
            </Modal>
            <Footer/>
        </div>
    );
};

export default ActivityItem;
